import { CruiseDetailsPlaceholderModel } from "@cruisen/react-shared"
import {
  INotificationAction,
  PaymentRequestID,
  PaymentRequestNotificationData,
  TripID,
  TripSearchResultRelatedNotificationData,
} from "@cruisen/contract"
import { _rootStore } from "../models/helpers/useStores.ts"
import { getISOString } from "../utils/dates.ts"
import { toJS } from "mobx"
import { getTrip } from "./firestore/trips.ts"

export async function openTrip(tripId: TripID) {
  if (!_rootStore.activeTrip || _rootStore.activeTrip.id !== tripId) {
    const notificationTrip = await getTrip(tripId)
    if (notificationTrip) {
      _rootStore.setProp("cruiseDetailsPlaceholderData", null)
      _rootStore.setProp("activeTrip", notificationTrip)
    }
  }
}

export async function openTripSearchResult(cruiseData: TripSearchResultRelatedNotificationData) {
  await openTrip(cruiseData.tripId)

  if (_rootStore.cruiseDetailsPlaceholderData?.id === cruiseData.tripSearchResultId) {
    _rootStore.setProp("cruiseDetailsPlaceholderData", null)
  } else {
    _rootStore.setProp(
      "cruiseDetailsPlaceholderData",
      CruiseDetailsPlaceholderModel.create({
        id: cruiseData.tripSearchResultId,
        name: cruiseData.cruiseSailingName,
        lowestPrice: cruiseData.cruiseSailingLowestPrice,
        lowestPricePP: cruiseData.cruiseSailingLowestPricePP,
        startDate: getISOString(cruiseData.cruiseSailingStartDate),
        endDate: getISOString(cruiseData.cruiseSailingEndDate),
        likes: cruiseData.cruiseSailingLikes,
        lineLogo: cruiseData.cruiseSailingLineLogo,
        lineName: cruiseData.cruiseSailingLineName,
        imageUrl: cruiseData.cruiseSailingHeroImage,
      }),
    )
  }
}

export async function openPaymentRequestDetails(
  tripId: TripID,
  paymentRequestId: PaymentRequestID,
) {
  await openTrip(tripId)

  _rootStore.setProp("cruiseDetailsPlaceholderData", null)

  if (_rootStore.paymentRequest === paymentRequestId) {
    _rootStore.setProp("paymentRequest", null)
  } else {
    _rootStore.setProp("paymentRequest", paymentRequestId)
  }
}

export function handleNotificationAction(
  action: Pick<INotificationAction, "id" | "url">,
  rawNotificationData: Record<string, unknown>,
): void {
  let notificationData = rawNotificationData
  if (typeof notificationData.json === "string") {
    try {
      const extraData = JSON.parse(notificationData.json)
      notificationData = {
        ...notificationData,
        ...extraData,
      }
      delete notificationData.json
    } catch (err) {
      console.error("Error parsing notification data", { error: err, json: notificationData.json })
    }
  }

  console.log("handle notification action", { action, notificationData })

  switch (action.id) {
    case "openTripSearchResult": {
      const cruiseData = toJS(notificationData) as TripSearchResultRelatedNotificationData
      openTripSearchResult(cruiseData).catch((error) =>
        console.log("could not open trip search result", { error, notificationData }),
      )
      break
    }
    case "openPaymentRequest": {
      const paymentRequest = (notificationData as PaymentRequestNotificationData).paymentRequest
      openPaymentRequestDetails(paymentRequest.tripId, paymentRequest.id).catch((error) =>
        console.log("could not open payment request details", { error, notificationData }),
      )
      break
    }
    case "openLinkInBrowser":
      window.open(action.url ?? "https://www.cruisen.com/", "_blank")
      break
    default:
      if (typeof notificationData.tripId === "string") {
        openTrip(notificationData.tripId).catch((error) =>
          console.log("could not open trip", { error, notificationData }),
        )
      } else {
        console.warn("unknown notification action", { action })
      }
  }
}
